enum SortType {
    BLANK,
}

export default SortType;
